<div class="or-p-32-px">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center">{{ header }}</span>
  </div>
  <div class="or-mb-20-px" [class.or-text-align-center]="centerMessage">
    <span class="or-text-md" [class.or-text-align-center]="centerMessage" [innerHTML]="message"></span>
  </div>
  <div class="or-d-flex or-justify-content-center">
    <button class="button-primary-style or-h-48-px or-w-60-pc or-head-sm" (click)="closeModal()">{{ btnTxt }}</button>
  </div>
</div>
